// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import * as Sentry from '@sentry/react';
import { SchemaValidationError } from '@/utilities/schema-validation';
import { Mutation } from '@tanstack/react-query';
import axios from 'axios';

/** Reports a failed query or mutation to Sentry unless it is expected or already reported. */
export function reportRequestError(error: unknown) {
  if (error instanceof SchemaValidationError) {
    return;
  }

  // Only capture 500+ errors globally; let components handle 4xx errors
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status && status >= 500) {
      Sentry.captureException(error);
    }
  } else {
    // Non-Axios errors should always be captured
    Sentry.captureException(error);
  }
}

/** Reports a failed mutation to Sentry unless the mutation reports its own errors. */
export function reportMutationError(
  error: unknown,
  mutation: Mutation<unknown, unknown>
) {
  if (mutation.meta?.isErrorReported) {
    return;
  }

  reportRequestError(error);
}
